export const listIndices = /* GraphQL */ `
  query ListIndices
  {
    listIndexs {
      items {
        id
        name
      }
    }
  }
`

export const listUserPortfolios = /* GraphQL */ `
  query ListUserPortfolios(
    $owner: String!
  )
  {
    listPortfoliosByOwner(owner: $owner) {
      items {
        id
        name
      }
    }
  }
`

export const listFavorites = /* GraphQL */ `
  query ListFavorites {
    listFavorites(favoriteType: "CHARTS") {
      items {
        favoriteType
        id: objectId
        name: objectName
        orderNo
        objectType
      }
    }
  }
`

export const DEFAULT_ITEM = 'id isin name'
export const DEFAULT_SHARE_ETF_ITEM = 'id isin name assetClass'
